import * as THREE from 'three';
import type { StageDef } from './stages';

interface BackdropEntry { texture: THREE.Texture; ready: boolean; promise: Promise<THREE.Texture> }
export class BackdropManager {
  readonly mesh = new THREE.Mesh(new THREE.PlaneGeometry(37.5,25), new THREE.MeshBasicMaterial({ depthWrite:false }));
  status: 'loading' | 'ready' | 'error' = 'loading';
  path = '';
  private generation = 0;
  private disposed = false;
  private readonly entries = new Map<string, BackdropEntry>();
  constructor() { this.mesh.position.set(0,-1.2,-3); }
  setStage(stage: StageDef): void {
    const generation = ++this.generation;
    this.path = stage.background; this.status = 'loading';
    this.mesh.material.map = null; this.mesh.material.color.set('#403c33'); this.mesh.material.needsUpdate = true;
    const apply = (texture: THREE.Texture) => {
      if (this.disposed || generation !== this.generation) return;
      this.mesh.material.map = texture; this.mesh.material.color.set('#ffffff'); this.mesh.material.needsUpdate = true; this.status = 'ready';
    };
    let entry = this.entries.get(stage.background);
    if (!entry) {
      let resolve!: (value: THREE.Texture) => void;
      let reject!: (reason?: unknown) => void;
      const promise = new Promise<THREE.Texture>((yes,no) => { resolve=yes;reject=no; });
      const texture = new THREE.TextureLoader().load(stage.background, (loaded) => {
        if (this.disposed) { loaded.dispose(); return; }
        const current=this.entries.get(stage.background); if(current)current.ready=true;
        resolve(loaded);
      }, undefined, (error) => { this.entries.delete(stage.background);reject(error); });
      texture.colorSpace = THREE.SRGBColorSpace; texture.magFilter = THREE.NearestFilter; texture.minFilter = THREE.NearestFilter; texture.generateMipmaps = false;
      entry={ texture,ready:false,promise }; this.entries.set(stage.background,entry);
    }
    if (entry.ready) { apply(entry.texture); return; }
    void entry.promise.then(apply).catch(() => { if (!this.disposed && generation===this.generation) this.status='error'; });
  }
  dispose(): void {
    this.disposed=true; this.generation++;
    for(const entry of this.entries.values())entry.texture.dispose();
    this.entries.clear(); this.mesh.geometry.dispose(); this.mesh.material.dispose();
  }
}
